import axios from "axios";
import Config from "../utilities/Config";
const BASE_URL = `${Config.baseUrl}api/admin`;

class AdminUserRequests {
  getHeaders() {
    const token = localStorage.getItem("txtconnect_ng_admin_token");
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
  }

  async getAdminUser() {
    try {
      const headers = this.getHeaders();
      const response = await axios.get(`${BASE_URL}/all/team_member`, headers);
      return {
        success: true,
        message: "Admin user fetched successfully",
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.reason || "An error occurred",
        data: null,
      };
    }
  }

  // Show Team Member
  async showTeamMember(teamMemberId) {
    try {
      const headers = this.getHeaders();
      const response = await axios.get(
        `${BASE_URL}/show/team_member/${teamMemberId}`,
        headers
      );
      return {
        success: true,
        message: "Team member fetched successfully",
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.reason || "An error occurred",
        data: null,
      };
    }
  }

  // Add Team Member
  async addTeamMember(teamMemberData) {
    try {
      const headers = this.getHeaders();
      const response = await axios.post(
        `${BASE_URL}/add/team_member`,
        teamMemberData,
        headers
      );
      return {
        success: true,
        message: "Team member added successfully",
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "An error occurred",
        data: null,
      };
    }
  }

  // Update Team Member
  async updateTeamMember(payload) {
    try {
      const headers = this.getHeaders();
      const response = await axios.put(
        `${BASE_URL}/update/team_member`,
        payload,
        headers
      );
      return {
        success: true,
        message: "Team member updated successfully",
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.reason || "An error occurred",
        data: null,
      };
    }
  }

  // Delete Team Member
  async deleteTeamMember(payload) {
    try {
      const headers = this.getHeaders();
      const response = await axios.post(
        `${BASE_URL}/destroy/team_member`,
        payload,
        headers
      );
      return {
        success: true,
        message: "Team member deleted successfully",
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.reason || "An error occurred",
        data: null,
      };
    }
  }

  // Update account status
  async updateAccountStatus(payload) {
    try {
      const headers = this.getHeaders();
      const response = await axios.post(
        `${BASE_URL}/update/account_status`,
        payload,
        headers
      );
      return {
        success: true,
        message: "Account status updated successfully",
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.reason || "An error occurred",
        data: null,
      };
    }
  }
}

const adminUserRequests = new AdminUserRequests();
export default adminUserRequests;
